
import { ApiService } from '@/services/ApiService';
import DocumentUploadArea from '@/components/DocumentUploadArea.vue'
import { error } from '@/services/LoggerService';
import mixins from 'vue-typed-mixins';
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import FieldValidationMixin from "@/mixins/FieldValidationMixins";
export default mixins(SnackbarNotifierMixin,FieldValidationMixin).extend({
  name: 'ConsigneeDocumentUploadLogin',
  components: {DocumentUploadArea, SnackbarNotifier},
  data: () =>({
    title: 'Recipient Document Submission',
    isLoading: false,
    logicalBarrelId: '',
    firstName: '',
    lastName: '',
    validated: false,
    uploadInfo: {}
  }),
  computed: {
    proceedBtnDisabled(){
      return (this.formattedTrn === '' || this.firstName === '' || this.lastName === '' || this.isLoading || !this.trnMatchPattern(this.formattedTrn));
    },
    proceedBtnTitle(){
      return this.isLoading ? '' : 'Proceed';
    }
  },
  methods: {
    async validate(){
      try{
        this.isLoading = true;
        let result = await ApiService.Instance.validateDocumentUploadUser({
          logicalBarrelId: this.logicalBarrelId,
          trn: this.formattedTrn,
          firstName: this.firstName,
          lastName: this.lastName
        });
        if(result && result.instruction){
          this.uploadInfo = result;
          this.validated = true;
        }
        this.isLoading = false;
      }
      catch(err){
        //@ts-ignore
        if(err.response.data.errorType == "IncorrectCredentials"){
          this.showNotifier({
            message: 'Invalid Information',
            snackbarType: "error",
          });
        }
        else{
          this.showNotifier({
          message: 'Validation Failed',
          snackbarType: "error",
        });
        }
        
        this.isLoading = false;
        error(err);
        throw new Error('Failed Validation');
      }
    }
  },
  async mounted(){
    this.logicalBarrelId = this.$route.params.logicalBarrelId;
  }
})
